const getCurrentID = () => {
    const { search } = window.location;
    const params = new URLSearchParams(search);
    return params.get("post") ? params.get("post") : 0;
};

export { getCurrentID };
